import React from "react";
import { connect } from "react-redux";
import {
  Transition,
  Container,
  Header,
  Segment,
  Button
} from "semantic-ui-react";

class ListadoAvisos extends React.Component {
  state = { visible: false };

  componentDidMount() {
    this.setState(state => ({ visible: true }));
  }

  handleVolver = () => this.props.history.goBack();

  render() {
    return (
      <Transition.Group animation="scale" duration={250}>
        {this.state.visible && (
          <Container textAlign="center">
            <Segment>
              <Button
                content="Cerrar"
                floated="right"
                color="pink"
                icon="cancel"
                onClick={this.handleVolver}
              />
              <Header>Listado de Avisos</Header>
            </Segment>
            <Segment />
          </Container>
        )}
      </Transition.Group>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ListadoAvisos);



// WEBPACK FOOTER //
// ./src/pages/listados/ListadoAvisos.jsx